class SearchDeviceOption {
  data;

  label;

  constructor(data, label) {
    this.data = data;
    this.label = label;
  }

  async fetchDetails() {
    return this.data;
  }
}

export default SearchDeviceOption;
